import { Group, Tab, Type } from '../const';

/**
 * @function updateForTabs
 * @param { array } menus
 * @param { array } tabs
 * @returns { array }
 */
function updateForTabs(menus, tabs) {
	let apps = Array.from(menus);

	for (let a = 0; a < apps.length; a++) {
		for (let b = 0; b < apps[a].groups.length; b++) {
			let newTabs = [];
			for (let c = 0; c < tabs.length; c++) {
				if (apps[a].groups[b][Group.Id] === tabs[c][Tab.GroupId]) {
					if (tabs[c][Tab.Id] !== '-2') {
						newTabs.push(tabs[c]);
					} else if (tabs[c][Tab.Id] === '-2') {
						newTabs = [];
					}
					apps[a].groups[b][Type.Tabs] = [...newTabs];
				}
			}
		}
	}

	return apps;
}

/**
 * @function updateForRoles
 * @param { array } menus
 * @param { array } roles
 * @returns { array }
 */
function updateForRoles(menus, roles) {
	let apps = Array.from(menus);
	for (let a = 0; a < apps.length; a++) {
		for (let b = 0; b < apps[a].groups.length; b++) {
			let newRoles = [];
			for (let c = 0; c < roles.length; c++) {
				if (apps[a].groups[b][Group.Id] === roles[c].groupId) {
					if (roles[c].id !== '-2') {
						newRoles.push(roles[c]);
					} else if (roles[c].id === '-2') {
						newRoles = [];
					}
					apps[a].groups[b].roles = [...newRoles];
				}
			}
		}
	}
	return apps;
}

/**
 * @function updateForSubtabs
 * @param { array } menus
 * @param { array } subtabs
 * @returns { array }
 */
function updateForSubtabs(menus, subtabs) {
	let apps = Array.from(menus);

	for (let a = 0; a < apps.length; a++) {
		for (let b = 0; b < apps[a].groups.length; b++) {
			for (let c = 0; c < apps[a].groups[b].tabs.length; c++) {
				let newSubtabs = [];
				for (let d = 0; d < subtabs.length; d++) {
					if (apps[a].groups[b].tabs[c].id === subtabs[d].subtabId) {
						newSubtabs.push(subtabs[d]);
					}
					apps[a].groups[b].tabs[c].subtabs = [...newSubtabs];
				}
			}
		}
	}
	return apps;
}

/**
 * @function updateMenuBySavingData
 * @param { array } menus
 * @param { object } updatedData
 * @returns { array }
 */
function updateMenuBySavingData(menus, updatedData) {
	const newData = Object.assign({}, updatedData);

	let results = [];

	if (newData[Type.Tabs]) {
		results = updateForTabs(menus, newData[Type.Tabs]);
	}

	if (newData[Type.Subtabs]) {
		results = updateForSubtabs(menus, newData[Type.Subtabs]);
	}

	if (newData[Type.Roles]) {
		results = updateForRoles(menus, newData[Type.Roles]);
	}

	return results;
}

export default updateMenuBySavingData;
